/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback } from "react";
import "../../css/integration.css";
import callApi from "../../utils/apiCaller";
import { Button, Card, RangeSlider } from "@shopify/polaris";
import { Row, Table, Col } from "reactstrap";
import { actFetchShowLoadingPage } from "../../actions/index";

import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

const BuyMultiStores = () => {
	const dispatch = useDispatch();
	const [extraStores, setExtraStores] = useState(5);
	const [extraCost, setExtraCost] = useState(30);
	const [copied, setCopied] = useState(false);
	const [storeName, setStoreName] = useState("");
	const listStore = useSelector((state) => state.listStore);
	const dataSettings = useSelector((state) => state.dataSettings);

	const changeExtraStore = useCallback((value) => {
		let cost = 0;
		if (value < 6) {
			cost = 6 * value;
		}
		if (5 < value && value < 11) {
			cost = 6 * 5 + 5 * (value - 5);
		}
		if (value > 10) {
			cost = 6 * 5 + 5 * 5 + 4 * (value - 10);
		}
		setExtraCost(cost);
		setExtraStores(value);
	});

	const buyExtraStores = () => {
		let params = {
			action: "activePlan",
			type: dataSettings.plan,
			subscription: dataSettings.subscription,
			dayProcess: 0,
			extraStores,
			extraCost,
		};
		dispatch(actFetchShowLoadingPage(true));
		callApi("get", params).then(async (res) => {
			if (res.data.state === 2) {
				Swal.fire({
					icon: "success",
					title: "Successfully",
					text: res.data.msg,
					showCloseButton: false,
					showConfirmButton: false,
					timer: 3000,
				}).then((result) => {
					window.location.reload();
				});
			} else {
				window.top.location.replace(res.data.confirmation_url);
			}
		});
	};

	return (
		<div style={{ marginTop: "20px" }} className="integration-page">
			{/* {listStore.length > 1 ? ( */}
			<Card sectioned title="Buy more slots to integrate">
				<Table
					className="multi-store-manager-table"
					responsive
					bordered
				>
					<thead className="text-center">
						<tr>
							<th>From 1 to 5 stores</th>
							<th>From 6 to 10 stores</th>
							<th> {">"} 10 stores</th>
						</tr>
					</thead>
					<tbody className="text-center">
						<tr>
							<td>
								<b>$6</b>/store
							</td>
							<td>
								<b>$5</b>/store
							</td>
							<td>
								<b>$4</b>/store
							</td>
						</tr>
					</tbody>
				</Table>
				<div>
					<div className="mt-2 mb-2">
						Buy more: <b>{extraStores} slots</b> - Extra cost:{" "}
						<b>${extraCost}</b>
					</div>
					<div className="d-flex">
						<div className="w-75 mt-3">
							<RangeSlider
								value={extraStores}
								min={1}
								max={20}
								onChange={changeExtraStore}
								output
							/>
						</div>
						<div className="w-25 text-left ml-3">
							<Button onClick={() => buyExtraStores()} primary>
								Buy Now
							</Button>
						</div>
					</div>
				</div>
			</Card>
		</div>
	);
};

export default BuyMultiStores;
